import type { FileKind, RevisionState } from '@felix/domain';
import { IconFileTypeDocx, IconFileTypePdf, IconFileTypeXls, IconPhoto } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { StatusBadge } from '../../StatusBadge.js';
import classes from './Documents.module.css';
import { revisionTone } from './library.js';

/** Harfli dosya türü karosu ("W" Word, "X" Excel, "PDF"; gemi-ism-formlari.jpeg bilgi şeridi). */
const TILE: Record<FileKind, string> = { docx: 'W', xlsx: 'X', pdf: 'PDF', jpg: '', png: '' };

/**
 * Dosya türü ikonu. `tile`: bilgi şeridi, araç çubuğu ve bilgi kartındaki renkli harf karosu;
 * `glyph`: ilgili dokümanlar ve eklerdeki doküman çizimi (PDF kırmızı, Word mavi). Renkler
 * token'lardan (CSS); ekran okuyucudan gizlenir, türün adı yanında yazar.
 */
export function FileKindIcon({
  kind,
  variant = 'tile',
  size = 20,
}: {
  kind: FileKind;
  variant?: 'tile' | 'glyph';
  size?: number;
}) {
  if (variant === 'glyph' || kind === 'jpg' || kind === 'png') {
    const Icon =
      kind === 'pdf'
        ? IconFileTypePdf
        : kind === 'xlsx'
          ? IconFileTypeXls
          : kind === 'docx'
            ? IconFileTypeDocx
            : IconPhoto;
    return (
      <Icon size={size} stroke={1.6} className={classes.kindGlyph} data-kind={kind} aria-hidden />
    );
  }
  return (
    <span
      className={classes.kindTile}
      data-kind={kind}
      style={{ width: size, height: size }}
      aria-hidden
    >
      {TILE[kind]}
    </span>
  );
}

/** Revizyon durumu rozeti (hap; README tasarım değerleri). */
export function RevisionBadge({ state }: { state: RevisionState }) {
  const { t } = useTranslation();
  return <StatusBadge tone={revisionTone(state)}>{t(`documents.states.${state}`)}</StatusBadge>;
}
